import { apiClient } from '@/shared/api/client'

export async function getPurchaseOrders() {
  const response = await apiClient.get('/purchase/purchase-orders')
  return response.data
}

export async function createPurchaseOrder(payload) {
  const response = await apiClient.post('/purchase/purchase-orders', payload)
  return response.data
}

export async function getNextPurchaseOrderNumber(date) {
  const response = await apiClient.get(
    '/purchase/purchase-orders/next-number',
    {
      params: date ? { date } : {},
    },
  )
  return response.data
}

export async function downloadPurchaseOrderPDF(purchaseOrderId) {
  const response = await apiClient.get(
    `/purchase/purchase-orders/${purchaseOrderId}/export`,
    { responseType: 'blob' },
  )

  return response.data
}
